import { render, staticRenderFns } from "./ProveedorList.vue?vue&type=template&id=d5cf4424&scoped=true&"
import script from "./ProveedorList.vue?vue&type=script&lang=js&"
export * from "./ProveedorList.vue?vue&type=script&lang=js&"
import style0 from "./ProveedorList.vue?vue&type=style&index=0&id=d5cf4424&lang=scss&scoped=true&"
import style1 from "./ProveedorList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cf4424",
  null
  
)

export default component.exports